/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class CoreApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `CoreApiModule.forRoot()`
 */
export interface CoreApiConfigurationParams {
  rootUrl?: string;
}
